export default {
  DISTRIBUTE_UNASSIGNED_BALANCE_COMMAND: Symbol.for('DISTRIBUTE_UNASSIGNED_BALANCE_COMMAND'),
  DISTRIBUTE_UNASSIGNED_BALANCE_REPOSITORY: Symbol.for('DISTRIBUTE_UNASSIGNED_BALANCE_REPOSITORY'),
};
